import { useState } from "react";
import type { ListQuery, SortOrder } from "@/api/types";

export type ListPatch = { page?: number; pageSize?: number; sort?: string; order?: SortOrder };

/** Paging/sorting state for tables embedded in detail pages (the page URL owns the tab only). */
export function useLocalList<F extends object>(filters: F, defaults: { sort: string; order?: SortOrder; pageSize?: number }) {
  const [state, setState] = useState({ page: 1, pageSize: defaults.pageSize ?? 25, sort: defaults.sort, order: defaults.order ?? ("desc" as SortOrder) });
  const query: ListQuery<F> = { ...state, filters };
  return [query, (patch: ListPatch) => setState((s) => ({ ...s, ...patch }))] as const;
}
